<template>
    <div class="formulario-beneficiario">
        <div class="row">
            <div class=" col m6 s12">
                <label for="beneficiario_nome">Nome do beneficiário</label>
                <input
                    data-vv-delay="1000"
                    :class="errors.has('beneficiario_nome') ? 'invalid' : ''"
                    class="validate active form-control"
                    id="beneficiario_nome"
                    name="beneficiario_nome"
                    type="text"
                    v-model="formData.beneficiario_nome"
                />
            </div>
            <div class=" col m6 s12">
                <label
                    for="beneficiario_data_nascimento"
                    :class="checkValue(formData.beneficiario_data_nascimento)"
                >
                    Data nascimento do beneficiário
                </label>
                <masked-input
                    v-validate="'date_format:dd/MM/yyyy|mydata'"
                    data-vv-delay="1000"
                    :class="
                        errors.has('beneficiario_data_nascimento')
                            ? 'invalid'
                            : ''
                    "
                    class="validate form-control"
                    name="beneficiario_data_nascimento"
                    id="beneficiario_data_nascimento"
                    type="text"
                    v-model="formData.beneficiario_data_nascimento"
                    mask="11/11/1111"
                />
                <span
                    class="helper-text red-light-text"
                    data-success="right"
                    v-if="errors.has('beneficiario_data_nascimento')"
                >
                    Data incorreta
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import MaskedInput from "vue-masked-input";

export default {
    inject: ["$validator"],
    components: {
        MaskedInput
    },
    props: ["beneficiario"],
    data: () => ({
        formData: {
            beneficiario_nome: "",
            beneficiario_data_nascimento: ""
        }
    }),
    async created() {
        if (this.beneficiario) {
            this.formData.beneficiario_nome = this.beneficiario.beneficiario_nome;
            this.formData.beneficiario_data_nascimento = this.beneficiario
                .beneficiario_data_nascimento
                ? moment(this.beneficiario.beneficiario_data_nascimento).format(
                      "DD/MM/YYYY"
                  )
                : "";
        }
    },
    watch: {
        formData: {
            handler: function() {
                this.$emit("newdata", [
                    this.formData.beneficiario_nome,
                    this.formData.beneficiario_data_nascimento
                ]);

                this.$emit("input", this.formData);
            },
            deep: true
        }
    },
    methods: {
        checkValue(value) {
            if (value !== "") {
                return "active";
            }
            return "";
        }
    }
};
</script>

<style>
.formulario-beneficiario.step-parent {
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormularioBeneficiario.vue